import assetAppleAppStoreBadgeCz from './apple-app-store-badge_cz.svg';
import assetAppleAppStoreBadgeDe from './apple-app-store-badge_de.svg';
import assetAppleAppStoreBadgeEn from './apple-app-store-badge_en.svg';
import assetAppleAppStoreBadgeFr from './apple-app-store-badge_fr.svg';
import assetAppleAppStoreBadgeHu from './apple-app-store-badge_hu.svg';
import assetAppleAppStoreBadgeNl from './apple-app-store-badge_nl.svg';
import assetAppleAppStoreBadgePl from './apple-app-store-badge_pl.svg';
import assetAppleAppStoreBadgeRo from './apple-app-store-badge_ro.svg';
import assetAppleAppStoreBadgeSk from './apple-app-store-badge_sk.svg';
import assetGooglePlayBadgeCz from './google-play-badge_cz.svg';
import assetGooglePlayBadgeDe from './google-play-badge_de.svg';
import assetGooglePlayBadgeEn from './google-play-badge_en.svg';
import assetGooglePlayBadgeFr from './google-play-badge_fr.svg';
import assetGooglePlayBadgeHu from './google-play-badge_hu.svg';
import assetGooglePlayBadgeNl from './google-play-badge_nl.svg';
import assetGooglePlayBadgePl from './google-play-badge_pl.svg';
import assetGooglePlayBadgeRo from './google-play-badge_ro.svg';
import assetGooglePlayBadgeSk from './google-play-badge_sk.svg';
export enum StoreNames {
  AppStoreCz = 'AppStoreCz',
  AppStoreDe = 'AppStoreDe',
  AppStoreEn = 'AppStoreEn',
  AppStoreFr = 'AppStoreFr',
  AppStoreHu = 'AppStoreHu',
  AppStoreNl = 'AppStoreNl',
  AppStorePl = 'AppStorePl',
  AppStoreRo = 'AppStoreRo',
  AppStoreSk = 'AppStoreSk',
  PlayStoreCz = 'PlayStoreCz',
  PlayStoreDe = 'PlayStoreDe',
  PlayStoreEn = 'PlayStoreEn',
  PlayStoreFr = 'PlayStoreFr',
  PlayStoreHu = 'PlayStoreHu',
  PlayStoreNl = 'PlayStoreNl',
  PlayStorePl = 'PlayStorePl',
  PlayStoreRo = 'PlayStoreRo',
  PlayStoreSk = 'PlayStoreSk',
}

export const storeBadgeIconAssets: {
  [key in StoreNames]: string;
} = {
  [StoreNames.AppStoreCz]: assetAppleAppStoreBadgeCz,
  [StoreNames.AppStoreDe]: assetAppleAppStoreBadgeDe,
  [StoreNames.AppStoreEn]: assetAppleAppStoreBadgeEn,
  [StoreNames.AppStoreFr]: assetAppleAppStoreBadgeFr,
  [StoreNames.AppStoreHu]: assetAppleAppStoreBadgeHu,
  [StoreNames.AppStoreNl]: assetAppleAppStoreBadgeNl,
  [StoreNames.AppStorePl]: assetAppleAppStoreBadgePl,
  [StoreNames.AppStoreRo]: assetAppleAppStoreBadgeRo,
  [StoreNames.AppStoreSk]: assetAppleAppStoreBadgeSk,
  [StoreNames.PlayStoreCz]: assetGooglePlayBadgeCz,
  [StoreNames.PlayStoreDe]: assetGooglePlayBadgeDe,
  [StoreNames.PlayStoreEn]: assetGooglePlayBadgeEn,
  [StoreNames.PlayStoreFr]: assetGooglePlayBadgeFr,
  [StoreNames.PlayStoreHu]: assetGooglePlayBadgeHu,
  [StoreNames.PlayStoreNl]: assetGooglePlayBadgeNl,
  [StoreNames.PlayStorePl]: assetGooglePlayBadgePl,
  [StoreNames.PlayStoreRo]: assetGooglePlayBadgeRo,
  [StoreNames.PlayStoreSk]: assetGooglePlayBadgeSk,
};
